import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';
import { ArrowLeft } from 'lucide-react';
import usePageTitle from '../hooks/usePageTitle';
import { BRAND_INFO } from '../data/mock';

const NotFoundPage = () => {
  usePageTitle(`Page not found | ${BRAND_INFO.name}`);
  return (
    <>
      <Header />
      <main className="pt-28 lg:pt-36 pb-24 min-h-[70vh] flex items-center bg-cream-100">
        <div className="container-page text-center">
          <p className="eyebrow justify-center">404</p>
          <h1 className="font-display text-display-lg text-ink-900 mt-4">This page wandered off.</h1>
          <p className="mt-4 text-ink-600 max-w-xl mx-auto">
            The page you tried to reach is not here. Let&rsquo;s get you back to the home page so you can keep exploring {BRAND_INFO.name}.
          </p>
          <Link to="/" className="btn-brick mt-8 inline-flex">
            <ArrowLeft className="w-4 h-4" /> Back home
          </Link>
        </div>
      </main>
      <Footer />
    </>
  );
};

export default NotFoundPage;
